export default function GrantWriting() {
  return (
    <section className="py-20 lg:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-block bg-[#D4AF37] text-white px-4 py-1.5 rounded-full text-xs font-semibold tracking-wide">
                GRANT & PROPOSAL WRITING
              </div>
              <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Winning Proposals<br />
                <span className="text-[#D4AF37]">Funding Success</span>
              </h2>
            </div>

            <p className="text-gray-700 text-base leading-relaxed">
              Our expert grant writers and proposal specialists have helped numerous organizations secure funding for their projects. We understand the intricacies of grant applications and craft compelling narratives that resonate with funders.
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full mb-4">
                  <i className="ri-file-edit-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Grant Applications</h4>
                <p className="text-sm text-gray-600">
                  Comprehensive grant application development and submission support
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full mb-4">
                  <i className="ri-presentation-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Proposal Writing</h4>
                <p className="text-sm text-gray-600">
                  Professional business proposals that win contracts and partnerships
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full mb-4">
                  <i className="ri-search-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Funding Research</h4>
                <p className="text-sm text-gray-600">
                  Identify and match your organization with suitable funding opportunities
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full mb-4">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Strategy Development</h4>
                <p className="text-sm text-gray-600">
                  Long-term funding strategies aligned with your organizational goals
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <button className="bg-[#D4AF37] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#C19B2E] transition-all whitespace-nowrap">
                Request Consultation
              </button>
              <button className="border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-full font-semibold hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap">
                View Portfolio
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/bfe8a164528863f233b71150a1db032c.jpg" 
                alt="Grant Writing Services" 
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-md rounded-2xl p-6 shadow-xl">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-3xl font-bold text-gray-900">95%</div>
                  <div className="text-sm text-gray-600">Success Rate</div>
                </div>
                <div className="w-px h-12 bg-gray-300"></div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">$50M+</div>
                  <div className="text-sm text-gray-600">Secured Funding</div>
                </div>
                <div className="w-px h-12 bg-gray-300"></div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">200+</div>
                  <div className="text-sm text-gray-600">Successful Grants</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
